import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FileUploadS3 } from "../../../utils/FileUpload";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import SuccessMessages from "../../../constants/SucessMessages.json";
import { FlexContainer } from "../../../constants/assets/containers";
import CameraAdd from "sushiweb/Icons/all/CameraAdd";
import CameraFill from "sushiweb/Icons/all/CameraFill";
import variables from "../../../constants/assets/variables";

const MAX = 1048576;

const ImageUploader = (props) => {
  const {
    state,
    id,
    activeItem,
    presign_url,
    callback_key,
    uploadUrl,
    setStatus,
    setUploadedImageName,
    imageKey,
    keyName,
    onError,
    disabled,
    maxSize,
    handleImageChange,
    handleImageClick,
    imageUrl,
    handleImageUrlChange,
    noAckCall, //applicable when there is no need to hit ack api call
  } = props;

  const [activeUrl, setActiveUrl] = useState("");
  const [activeFile, setActiveFile] = useState("");

  const isClickFunctionDefined = () => {
    return handleImageClick && typeof handleImageClick === "function";
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (isClickFunctionDefined()) {
      handleImageClick();
      return;
    }
    const files = e.target.files;
    if (maxSize && files[0].size > maxSize * MAX) {
      setStatus({
        type: "error",
        message: "Please select file less than " + maxSize + " MB",
      });
      return;
    }
    handleImageChange(files[0]);
    setActiveFile(files[0]);
    setUploadedImageName(files[0].name);
    // this line right below will reset the
    // input field so if you removed it you can re-add the same file
    e.target.value = "";
  };

  useEffect(() => {
    if (callback_key && presign_url && activeFile) {
      FileUploadS3(
        callback_key,
        presign_url,
        activeFile,
        uploadUrl,
        keyName,
        noAckCall
      )
        .then((url) => {
          handleImageUrlChange();
          setStatus({
            type: "success",
            message: SuccessMessages.FILE_UPLOAD_SUCCESS,
          });
        })
        .catch((err) => {
          if (onError) {
            if (typeof onError == "function") {
              onError(err);
              return;
            }
          }
          setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
          });
        });
    } else if (callback_key && presign_url && !activeFile) {
      setStatus({ type: "error", message: Errors.NO_FILE_SELECTED });
    }
  }, [callback_key, presign_url]);

  useEffect(() => {
    setActiveUrl(imageUrl);
  }, [imageUrl]);

  useEffect(() => {
    if (state === "Edit") {
      setActiveUrl(activeItem[imageKey]);
    }
  }, [state]);

  return (
    <ImageUpload id={id} url={activeUrl}>
      <ImageMask justify="center">
        {state === "Edit" ? (
          <CameraFill color={variables.white} />
        ) : (
          <CameraAdd color={variables.white} />
        )}
      </ImageMask>
      <input
        type={isClickFunctionDefined() ? undefined : "file"}
        id="file-input"
        onChange={handleChange}
        onClick={isClickFunctionDefined() ? handleChange : undefined}
        accept="image/png,image/jpeg"
      />
    </ImageUpload>
  );
};

ImageUploader.defaultProps = {
  disabled: false,
  imageKey: "thumbnail",
};

const ImageUpload = styled.div`
  background-image: ${(props) => (props.url ? `url(${props.url})` : "unset")};
  width: 80px;
  margin-bottom: 30px;
  background-color: ${variables.black};
  background-size: contain;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.4);
  height: 5rem;
  opacity: 0.6;
  background-position: center;
  border-radius: 6px;
  background-repeat: no-repeat;
  #file-input {
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;

const ImageMask = styled(FlexContainer)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  img {
    width: 10rem;
    height: 10rem;
  }
`;

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(userActions.setStatus, dispatch),
    setUploadedImageName: bindActionCreators(
      userActions.setUploadedImageName,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(ImageUploader);
